import { SocialMedia } from '../editor/settings/SocialSettings';
import { FacebookIcon, InstagramIcon, NewTwitterRectangleIcon, TiktokIcon, WhatsappIcon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';

interface Props extends SocialMedia {
    icon: 'whatsapp' | 'instagram' | 'facebook' | 'x' | 'tiktok';
}

const SocialMediaIcon = ({ icon, ...props }: Props) => {
    // if (icon === 'whatsapp') return <Whatsapp {...props} />
    if (icon === 'whatsapp') return <HugeiconsIcon icon={WhatsappIcon} color={props.color as string} strokeWidth={props.strokeWidth as number} size={32} />;
    // if (icon === 'facebook') return <Facebook {...props} />
    if (icon === 'facebook') return <HugeiconsIcon icon={FacebookIcon} color={props.color as string} strokeWidth={props.strokeWidth as number} size={32} />;
    // if (icon === 'instagram') return <Instagram {...props} />
    if (icon === 'instagram') return <HugeiconsIcon icon={InstagramIcon} color={props.color as string} strokeWidth={props.strokeWidth as number} size={32} />;
    // if (icon === 'x') return <X {...props} />
    if (icon === 'x') return <HugeiconsIcon icon={NewTwitterRectangleIcon} color={props.color as string} strokeWidth={props.strokeWidth as number} size={32} />;
    if (icon === 'tiktok') return <HugeiconsIcon icon={TiktokIcon} color={props.color as string} strokeWidth={props.strokeWidth as number} size={32} />;
    return null;
}

export default SocialMediaIcon;
